import { jsx as t } from "react/jsx-runtime";
import { useMultiStyleConfig as m, FormHelperText as x } from "@chakra-ui/react";
const T = ({ children: o, ...r }) => {
  const e = m("FormTheme", r);
  return /* @__PURE__ */ t(x, { sx: e == null ? void 0 : e.helperText, ...r, children: o });
};
export {
  T as FormHelperText
};
//# sourceMappingURL=FormHelperText.es.js.map
